import {
  aiRecognition,
  cameraAudio,
  cameraResolution,
  deployment,
  dimensions,
  enhancedDetections,
  faceRecognition,
  fieldOfView,
  imageSensor,
  licensePlateRecognition,
  nightVision,
  opticalZoom,
  outdoorReady,
  smartDetections,
  tamperResistance,
} from "../properties";

export const physicalSecurityProperties = [
  dimensions,
  cameraResolution,
  imageSensor,
  fieldOfView,
  nightVision,
  opticalZoom,
  smartDetections,
  enhancedDetections,
  licensePlateRecognition,
  faceRecognition,
  aiRecognition,
  cameraAudio,
  outdoorReady,
  tamperResistance,
  deployment,
];
